import { useEffect, useState } from 'react';
import type { RenderPresetId } from '../../domain/render-preset';

export function workspaceLayout(_preset: RenderPresetId, view: { width: number; height: number }) {
  return view.width < 700 && view.height > view.width || view.width <= 960 && view.height <= 540 ? 'stacked' : 'docked';
}

/** Output formats share one stable desktop dock; compact windows retain film-first panels. */
export function useWorkspaceLayout(preset: RenderPresetId) {
  const [view, setView] = useState({ width: innerWidth, height: innerHeight });
  useEffect(() => {
    const resize = () => setView({ width: innerWidth, height: innerHeight });
    window.addEventListener('resize', resize); return () => window.removeEventListener('resize', resize);
  }, []);
  return { layout: workspaceLayout(preset, view) };
}
